<template>
  <div>
    <b-row class="m-1 mt-3 danh-sach-don-vi">
      <b-col sm="3" class="pr-0">
        <div class="light-box">
          <div class="form">
            <DxTreeList
              v-if="danhSachDonViCha && danhSachDonViCha.length > 0"
              id="treeList"
              :focused-row-enabled="checkValueDonVi"
              has-items-expr="Has_Items"
              :data-source="danhSachDonViCha"
              :column-auto-width="false"
              :word-wrap-enabled="false"
              :show-borders="false"
              :no-data-text="'Không có dữ liệu'"
              key-expr="Task_ID"
              parent-id-expr="Task_Parent_ID"
              :root-value="-1"
              :auto-expand-all="false"
              @focused-row-changed="onRowPrepared"
              :expanded-row-keys="expandedRowKeys"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="Nhập từ khóa tìm kiếm"
                v-model="timKiem"
              />
              <DxEditing
                :allow-ad="true"
                :select-text-on-edit-start="false"
                :use-icons="true"
                :auto-expand-all="false"
              >
              </DxEditing>
              <DxColumn
                :min-width="50"
                data-field="labelSearch"
                caption="Thứ tự đơn vị"
                :allow-editing="true"
                :auto-expand-all="false"
                calculate-sort-value="thuTu"
                id="ten-don-vi"
                sort-order="asc"
                :cell-template="renderItem"
              >
              </DxColumn>
            </DxTreeList>
            <BaseLoadingTable v-else  />
          </div>
        </div>
      </b-col>
      <b-col sm="9">
        <div class="light-box">
          <b-tabs content-class="mt-3">
            <b-tab active title="THÔNG TIN ĐƠN VỊ">
              <div class="d-flex justify-content-end mb-2" v-if="laXemChiTiet">
                <div class="btn-tab-position-area top">
                  <button
                    class="btn btn-danger mr-2"
                    @click="handleSyncData"
                  >
                    <div class="d-flex">
                      <span>Đồng bộ</span>
                    </div>
                  </button>
                  <button
                    class="btn btn-success mr-2"
                    @click="openImport"
                    button="Import"
                    v-if="
                      hasPermissionUser(PERMISSION_NAME.IMPORT.IMPORT_DON_VI)
                    "
                    variant="info"
                  >
                    <div class="d-flex">
                      <img
                        class="cursor-pointer"
                        @click="doSignOnFile(item)"
                        width="16px"
                        src="@/assets/images/icon/import-icon.svg"
                        alt="image"
                      />
                      <span class="ml-1">Import</span>
                    </div>
                  </button>
                  <button
                    class="btn btn-blue mr-2"
                    @click="openExport"
                    :disabled="isLoadingExport"
                    variant="info"
                    v-if="
                      hasPermissionUser(PERMISSION_NAME.IMPORT.EXPORT_DON_VI)
                    "
                    button="Export"
                  >
                    <div class="d-flex">
                      <img
                        class="cursor-pointer"
                        @click="doSignOnFile(item)"
                        width="16px"
                        src="@/assets/images/icon/export-icon.svg"
                        alt="image"
                      />
                      <span class="ml-1">Export</span>
                    </div>
                  </button>
                </div>
                <div class="btn-tab-position-area">
                  <base-button
                    v-if="
                      idDonVi && hasPermissionUser(PERMISSION_NAME.DON_VI.THEM)
                    "
                    @click="moModalTaoMoiDonVi"
                    variant="info"
                    class="btn search-information-btn text-right mr-2"
                    button="Thêm mới"
                  />
                  <base-button
                    @click="moModalSuaDonVi"
                    variant="info"
                    class="text-right mr-2"
                    v-if="
                      taoMoiDonVi &&
                      hasPermissionUser(PERMISSION_NAME.DON_VI.SUA)
                    "
                    button="Cập nhật"
                  />
                  <base-button
                    @click="moModalXoaDonVi"
                    class="text-right btn-red mr-2"
                    v-if="
                      hienThiXoaDonVi &&
                      hasPermissionUser(PERMISSION_NAME.DON_VI.XOA)
                    "
                    button="Xóa"
                  />
                </div>
              </div>
              <ChiTietDonVi
                :hienThiXoaDonVi="hienThiXoaDonVi"
                :chiTietDonVi="chiTietDonVi"
                v-if="laXemChiTiet"
              />
              <FormDonVi
                v-else
                ref="taoDonViModal"
                @layDanhSachDonVi="layDanhSachTatCaDonVi($event)"
                :la-sua-don-vi="laSuaDonVi"
                :chi-tiet-don-vi="chiTietDonVi"
                @closeForm="
                  laXemChiTiet = true;
                  laSuaDonVi = null;
                "
              />
            </b-tab>
            <b-tab title="CÁN BỘ TRỰC THUỘC">
              <div class="d-flex justify-content-end mb-2">
                <div class="btn-tab-position-area">
                  <base-button
                    v-if="
                      idDonVi &&
                      hasPermissionUser(
                        PERMISSION_NAME.DON_VI.THEM_CAN_BO_TRUC_THUOC
                      )
                    "
                    class="btn-green"
                    button="Thêm mới"
                    @click="moModalTaoCanBoTrucThuoc"
                  />
                </div>
              </div>
              <DanhSachCanBoTrucThuoc
                ref="DanhSachCanBoTrucThuoc"
                :idDonVi="idDonVi"
              />
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
      <TaoCanBoTrucThuocModal
        ref="taoCanBoModal"
        :value-don-vi="chiTietDonVi || {}"
        @layDanhSachCanBo="layDanhSachCanBoTrucThuocDonVi"
      />
      <ModalUploadImportFile
        ref="modalImport"
        :dataType="'DonVi'"
        :title="'Đơn vị'"
        @refreshData="layDanhSachDonViCha"
      />
      <ModalConfirm
        :title="(chiTietDonVi || {}).tenDonVi"
        ref="ModalXoaDonVi"
        :isLoading="isLoadingAction"
        @confirmed="xoaDonVi"
      />
      <div class="d-none">
        <b-icon icon="house-door" id="don-vi-icon" class="mr-2"> </b-icon>
      </div>
    </b-row>
  </div>
</template>

<script>
import ModalConfirm from "@/components/modal/ModalConfirm";
import { removeAccents } from "@/utils/normalize";
import ModalUploadImportFile from "@/components/modal/ModalUploadImportFile";
import { hasPermissionUser } from "@/utils/permissionUtils";
import {
  DANH_SACH_CAN_BO_TRUC_THUOC,
  DANH_SACH_KEY_CAN_BO_TRUC_THUOC,
  NO_RESULTS_TEXT,
  ROUTE_NAME,
  PERMISSION_NAME,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import {
  DxTreeList,
  DxEditing,
  DxColumn,
  DxSearchPanel,
} from "devextreme-vue/tree-list";
import DanhSachCanBoTrucThuoc from "@/components/pages/quan-ly-danh-muc/don-vi/DanhSachCanBoTrucThuoc";
import FormDonVi from "@/components/pages/quan-ly-danh-muc/don-vi/FormDonVi";
import TaoCanBoTrucThuocModal from "@/components/pages/quan-ly-danh-muc/don-vi/taoCanBoTrucThuocModal";
import ChiTietDonVi from "@/components/pages/quan-ly-danh-muc/don-vi/ChiTietDonVi";
import moment from "moment";
import BaseLoadingTable from "../../../common/BaseLoadingTable";
export default {
  name: "DanhSachDanhMucMenuHeThong",
  components: {
    BaseLoadingTable,
    TaoCanBoTrucThuocModal,
    FormDonVi,
    DxTreeList,
    DxColumn,
    DxEditing,
    DxSearchPanel,
    ModalUploadImportFile,
    ChiTietDonVi,
    ModalConfirm,
    DanhSachCanBoTrucThuoc,
  },
  data() {
    return {
      isLoadingExport: false,
      PERMISSION_NAME,
      isLoadingAction: false,
      laXemChiTiet: true,
      expandedRowKeys: [-1],
      timKiem: "",
      hienThiXoaDonVi: false,
      taoMoiCanBo: false,
      taoMoiDonVi: false,
      fieldNames: DANH_SACH_CAN_BO_TRUC_THUOC,
      fieldNamesKey: DANH_SACH_KEY_CAN_BO_TRUC_THUOC,
      danhSachDonViCon: [],
      chiTietDonVi: {},

      selected: null,
      idDonVi: "",
      ROUTE_NAME: ROUTE_NAME,
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      laSuaDonVi: null,
      chiTietSuaDonVi: {},
      checkValueDonVi: true,
    };
  },
  created() {
    this.layDanhSachDonViCha();
  },
  computed: {
    ...mapGetters({
      danhSachDonVi: "donVi/danhSachDonVi",
      canBoTrucThuoc: "donVi/danhSachCanBoTrucThuoc",
    }),
    danhSachDonViCha() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          label: item.tenDonVi,
          labelSearch: item.tenDonVi + " " + removeAccents(item.tenDonVi),
          ...item,
        };
      });
      return danhSach;
    },

    danhSachCanBoTrucThuoc() {
      if (!this.danhSachDonVi) {
        return [];
      }
      return (this.canBoTrucThuoc || []).items;
    },
  },
  methods: {
    hasPermissionUser,
    renderItem(element, data) {
      var icon = null;
      icon = document.getElementById("don-vi-icon").cloneNode(true);
      element.appendChild(icon);
      element.append(data.data.label);
    },
    handleSyncData() {},
    openImport() {
      this.$refs["modalImport"].showModal();
    },
    openExport() {
      let textSearch = document.getElementsByClassName("dx-texteditor-input")[0].value;
      let typeExport = "DonVi";
      this.isLoadingExport = true;
      this.$store
        .dispatch("importService/exportData", {
          type: typeExport,
          searchRequest: { DonVi: textSearch },
        })
        .then((res) => {
          this.isLoadingExport = false;
          this.$toasted.global.showSuccessMessage({
            message: "Export thành công",
          });
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Export${typeExport}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    },
    formatDateTime(date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY");
      }
      return date;
    },
    moModalXoaDonVi() {
      this.$refs.ModalXoaDonVi.showModal();
    },

    xoaDonVi() {
      this.isLoadingAction = true;
      this.$store
        .dispatch("donVi/xoaDonVi", this.chiTietDonVi.id)
        .then((res) => {
          this.isLoadingAction = false;
          if (res.data.succeeded) {
            this.layDanhSachDonViCha();
            this.hienThiXoaDonVi = false;
            this.$toasted.global.showSuccessMessage({
              message: "Xoá thành công",
            });
            this.$refs.ModalXoaDonVi.hideModal();
          } else {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: "Xoá không thành công",
            });
          }
        })
        .catch(() => {});
    },
    async layDanhSachTatCaDonVi(donVi) {
      this.chiTietDonVi = donVi;
      console.log(this.chiTietDonVi);
      this.checkValueDonVi = false;
      await setTimeout(() => {
        this.checkValueDonVi = true;
      }, 200);

      this.layDanhSachCanBoTrucThuocDonVi();
      this.layDanhSachDonViCha();
    },
    layDanhSachDonViCha() {
      this.$store.dispatch("donVi/layDanhSachDonViCha", {}).then(() => {});
    },
    moModalTaoMoiDonVi() {
      this.laXemChiTiet = false;
      this.laSuaDonVi = false;
      this.$nextTick(() => {
        this.$refs.taoDonViModal.refreshForm();
      });
    },
    moModalSuaDonVi() {
      this.laXemChiTiet = false;
      this.laSuaDonVi = true;
      this.$nextTick(() => {
        this.$refs.taoDonViModal.refreshForm();
      });
    },
    moModalTaoCanBoTrucThuoc() {
      this.$refs["taoCanBoModal"].showModal();
    },
    layChiTietDonVi(id) {
      this.$store.dispatch("donVi/layChiTietDonVi", {
        data: {
          id: id,
        },
        onSuccess: (result) => {
          this.chiTietDonVi = result || {};
        },
      });
    },
    onRowPrepared(e) {
      this.taoMoiDonVi = true;
      this.taoMoiCanBo = true;
      this.hienThiXoaDonVi = true;
      this.idDonVi = e.row.data.Task_ID;
      this.chiTietDonVi = {};
      this.layChiTietDonVi(e.row.data.Task_ID);
      this.$nextTick(() => {
        this.layDanhSachCanBoTrucThuocDonVi();
      });
    },
    layDanhSachCanBoTrucThuocDonVi() {
      this.$refs.DanhSachCanBoTrucThuoc.layDanhSachCanBoTrucThuocDonVi();
    },
  },
  watch: {
    laSuaDonVi: {
      handler() {
        this.$emit("setBreadcrumb", this.laSuaDonVi);
      },
      deep: true,
    },
    danhSachDonViCha: {
      handler() {
        if (this.danhSachDonViCha && this.danhSachDonViCha.length) {
          this.expandedRowKeys = [this.danhSachDonViCha[0].Task_ID];
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.danh-sach-don-vi {
  .btn-tab-position-area {
    &.top {
      top: -60px;
    }
    position: absolute;
    top: 11px;
  }
  .label {
    min-width: 150px;
    width: 150px;
    text-align: right;
  }
  .dx-toolbar-item-content > .dx-texteditor {
    width: 100% !important;
  }
  .dx-toolbar-after {
    padding: 0 !important;
    width: 100%;
  }
  .dx-treelist-search-panel {
    margin: 0 !important;
  }
  .custom-search {
    padding: 4px 8px;
    height: 35px;
    border-radius: 4px;
    border: 1px solid red;
  }
  .dx-treelist-cell-expandable {
    text-align: left !important;
  }
}
</style>
